import AttendantDashboardView from "@/views/attendant/dashboard/DashboardView";
import MyAccountView from "@/views/MyAccountView";

export default [
  {
    name: "pages.attendee.dashboard",
    path: "dashboard",
    component: AttendantDashboardView
  },
  {
    name: "pages.attendee.my-account",
    path: "my-account",
    component: MyAccountView
  }
];
